/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Lessons_EyebrowInputs */

const en_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Lessons`)
};

const es_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecciones de golf`)
};

const de_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfunterricht`)
};

const zh_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高尔夫课程`)
};

const ar_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دروس الغولف`)
};

const fr_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cours de golf`)
};

const vi_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bài học golf`)
};

const sw_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mafunzo ya Gofu`)
};

const th_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บทเรียนกอล์ฟ`)
};

const bs_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekcije golfa`)
};

const ja_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゴルフレッスン`)
};

const ko_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`골프 레슨`)
};

const pt_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aulas de golfe`)
};

const it_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lezioni di golf`)
};

const sv_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golflektioner`)
};

const nl_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golflessen`)
};

const da_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golftimer`)
};

const nb_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golftimer`)
};

const fi_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf-tunnit`)
};

const pl_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekcje golfa`)
};

const ru_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уроки гольфа`)
};

const tr_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Dersleri`)
};

const hi_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गोल्फ सबक`)
};

const id_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran Golf`)
};

const ms_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran Golf`)
};

const cs_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfové lekce`)
};

const el_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μαθήματα γκολφ`)
};

const he_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעורי גולף`)
};

const af_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golflesse`)
};

const hu_prices_lessons_eyebrow = /** @type {(inputs: Prices_Lessons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfórák`)
};

/**
* | output |
* | --- |
* | "Golf Lessons" |
*
* @param {Prices_Lessons_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_lessons_eyebrow = /** @type {((inputs?: Prices_Lessons_EyebrowInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Lessons_EyebrowInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_lessons_eyebrow(inputs)
	if (locale === "de") return de_prices_lessons_eyebrow(inputs)
	if (locale === "zh") return zh_prices_lessons_eyebrow(inputs)
	if (locale === "ar") return ar_prices_lessons_eyebrow(inputs)
	if (locale === "fr") return fr_prices_lessons_eyebrow(inputs)
	if (locale === "vi") return vi_prices_lessons_eyebrow(inputs)
	if (locale === "sw") return sw_prices_lessons_eyebrow(inputs)
	if (locale === "th") return th_prices_lessons_eyebrow(inputs)
	if (locale === "bs") return bs_prices_lessons_eyebrow(inputs)
	if (locale === "ja") return ja_prices_lessons_eyebrow(inputs)
	if (locale === "ko") return ko_prices_lessons_eyebrow(inputs)
	if (locale === "pt") return pt_prices_lessons_eyebrow(inputs)
	if (locale === "it") return it_prices_lessons_eyebrow(inputs)
	if (locale === "sv") return sv_prices_lessons_eyebrow(inputs)
	if (locale === "nl") return nl_prices_lessons_eyebrow(inputs)
	if (locale === "da") return da_prices_lessons_eyebrow(inputs)
	if (locale === "nb") return nb_prices_lessons_eyebrow(inputs)
	if (locale === "fi") return fi_prices_lessons_eyebrow(inputs)
	if (locale === "pl") return pl_prices_lessons_eyebrow(inputs)
	if (locale === "ru") return ru_prices_lessons_eyebrow(inputs)
	if (locale === "tr") return tr_prices_lessons_eyebrow(inputs)
	if (locale === "hi") return hi_prices_lessons_eyebrow(inputs)
	if (locale === "id") return id_prices_lessons_eyebrow(inputs)
	if (locale === "ms") return ms_prices_lessons_eyebrow(inputs)
	if (locale === "cs") return cs_prices_lessons_eyebrow(inputs)
	if (locale === "el") return el_prices_lessons_eyebrow(inputs)
	if (locale === "he") return he_prices_lessons_eyebrow(inputs)
	if (locale === "af") return af_prices_lessons_eyebrow(inputs)
	if (locale === "hu") return hu_prices_lessons_eyebrow(inputs)
	return en_prices_lessons_eyebrow(inputs)
});